import EligibilityWidgetOffers from './EligibilityWidgetOffers';
import EligibilityWidgetTokenEligible from './EligibilityWidgetTokenEligibile';
import ResetAction from './ResetAction';
import EligibilityWidgetTokenIneligible from './EligibilityWidgetTokenIneligible';
import type { WidgetOffer, WidgetOfferLink } from '../../../types/eligibilityWidget/EligibilityWidgetToken';

interface EligibilityWidgetTokenProps {
  isEligible: boolean;
  resetApp: () => void;
  offers: WidgetOffer[];
  links: WidgetOfferLink[];
  openLinks: (links: WidgetOfferLink[]) => void;
}

const EligibilityWidgetToken: React.FC<EligibilityWidgetTokenProps> = ({
  isEligible,
  resetApp,
  offers,
  links,
  openLinks,
}) =>
  isEligible ? (
    <EligibilityWidgetTokenEligible links={links} openLinks={openLinks}>
      <EligibilityWidgetOffers offers={offers} />
      <ResetAction onClick={resetApp} link />
    </EligibilityWidgetTokenEligible>
  ) : (
    <EligibilityWidgetTokenIneligible>
      <ResetAction onClick={resetApp} />
    </EligibilityWidgetTokenIneligible>
  );

export default EligibilityWidgetToken;
